import { render, staticRenderFns } from "./COProfiles.vue?vue&type=template&id=247db0f4&"
import script from "./COProfiles.vue?vue&type=script&lang=js&"
export * from "./COProfiles.vue?vue&type=script&lang=js&"
import style0 from "./COProfiles.vue?vue&type=style&index=0&id=247db0f4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports